<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from "@/components/widgets/raw-data.vue";
export default {
    props: {
        data: Object,
        posted: Boolean,
        viewFrom: {
            type: String,
            default: 'bidding'
        }
    },
    components: {
        LoadingTemplate,
        RawData
    },
    methods: {
        updateBACMember(row){
            this.$emit('updateBACMember', row);
        },
        addBACMember(){
            this.$emit('addBACMember');
        },
        deleteBACMember(row){
            this.$emit('deleteBACMember', row);
        },
        checkList(data){
            this.$store
                .dispatch("rfqbacsetting/UpdateBACMember", data)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                })
                .catch((err) => {
                    this.showToast('Something went wrong', "error");
                });
        }
    }
}
</script>
<template>
    <div>
        <template v-if="data.bacLoading">
            <LoadingTemplate />
        </template>
        <template v-if="!data.bacLoading && data.rfqBacSettings.length == 0">
            <h4 class="text-center">No data found...</h4>
        </template>
        <template v-if="!data.bacLoading && data.rfqBacSettings.length > 0">
            <div class="d-flex flex-row-reverse mb-3" v-if="!posted">
                <a href="javascript:void(0);" @click="addBACMember" class="text-primary border-primary border p-2">
                    <i class="bx bx-plus"></i> Add More BAC Member 
                </a>
            </div>
            <template v-for="(y, yIndex) in data.rfqBacSettings">
                <div 
                    class="py-1"
                    :class="{ 'broken-border-success': y.status.toUpperCase() !== 'PENDING', 'ms-3 px-3': viewFrom == 'bidding' }"
                    :key="y.id"
                >
                    <hr class="my-3" v-if="yIndex != 0">
                    <div class="d-flex align-items-center justify-content-between position-relative">
                        <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                        <div>
                            <span class="font-weight-bold text-light">{{y.employeeName ? y.employeeName : ''}}
                                <a href="javascript:void(0);" title="Edit BAC Member" class="font-size-16" @click="updateBACMember(y)" v-if="!posted && (y.status.toUpperCase() === 'PENDING' || $store.state.decrypt.isAdmin())">
                                    <i class="bx bx-edit"></i>
                                </a>
                                <a href="javascript:void(0);" class="text-danger font-size-16" title="Delete BAC Member" @click="deleteBACMember(y)" v-if="!posted && (y.status.toUpperCase() === 'PENDING' || $store.state.decrypt.isAdmin())">
                                    <i class="bx bx-trash"></i>
                                </a>
                            </span>
                            <div>
                                <small>{{y.bacName}} {{y.position}}</small>
                            </div>
                        </div>
                        <div
                            class="text-center font-weight-bold font-size-18"
                            :class="{
                                'text-warning': y.status.toUpperCase() === 'PENDING',
                                'text-green': y.status.toUpperCase() !== 'PENDING'
                            }"
                        >
                                {{y.status.toUpperCase() === 'APPROVED' ? 'DIGITALLY SIGNED': 'PENDING'}}
                        </div>
                    </div>
                    <div class="d-flex mt-1" v-if="!posted">
                        <div class="form-check form-checkbox-outline form-check-success mb-0">
                            <input
                                type="checkbox"
                                :id="`email-${y.id}`"
                                class="form-check-input"
                                v-model="y.receiveEmail"
                                @change="checkList(y)"
                            />
                            <label
                                :for="`email-${y.id}`"
                                class="form-check-label no-wrap"
                            >
                                Receive Email
                            </label>
                        </div>
                        <div class="form-check form-checkbox-outline form-check-success mb-0 ms-2">
                            <input
                                type="checkbox"
                                :id="`sms-${y.id}`"
                                class="form-check-input"
                                v-model="y.receiveSMS"
                                @change="checkList(y)"
                            />
                            <label
                                :for="`sms-${y.id}`"
                                class="form-check-label no-wrap"
                            >
                                Receive SMS
                            </label>
                        </div>
                        <div class="form-check form-checkbox-outline form-check-success mb-0 ms-2">
                            <input
                                type="checkbox"
                                :id="`chairman-${y.id}`"
                                class="form-check-input"
                                v-model="y.isChairman"
                                @change="checkList(y)"
                            />
                            <label
                                :for="`chairman-${y.id}`"
                                class="form-check-label no-wrap"
                            >
                                BAC Chairman
                            </label>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>